import React, {FC} from 'react';
import {connect} from 'react-redux';

import {getIsUserGlobalAdmin} from '../../../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {openInBrowser} from '../../../../../srcCommon/browser/openInBrowser';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {updateHasSeenDomainLoginBannerAction} from '../../../../store/data/preferences/preferencesActions';
import {getHasSeenDomainLoginBanner} from '../../../../store/data/preferences/preferencesSelectors';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {DomainLoginBanner} from './domainLoginBanner';

/*
 * Props.
 */

interface DomainLoginBannerContainerComponentProps {
  hasSeenDomainLoginBanner: boolean;
  openDomainLoginSettings: () => void;
  openHelpArticle: () => void;
  updateHasSeenDomainLoginBannerAction: () => void;
}

/*
 * Component.
 */

export const DomainLoginBannerContainerComponent: FC<DomainLoginBannerContainerComponentProps> = (props) => {
  if (!getIsUserGlobalAdmin || props.hasSeenDomainLoginBanner) {
    return null;
  }

  const onActionClick = () => {
    props.updateHasSeenDomainLoginBannerAction();
    props.openDomainLoginSettings();
  };

  const onLearnClick = () => {
    props.updateHasSeenDomainLoginBannerAction();
    props.openHelpArticle();
  };

  return (
    <DomainLoginBanner
      onDismissClick={props.updateHasSeenDomainLoginBannerAction}
      onActionClick={onActionClick}
      onLearnClick={onLearnClick}
    />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  hasSeenDomainLoginBanner: getHasSeenDomainLoginBanner,
}));

const mapDispatchToProps = {
  openDomainLoginSettings: () => navigateToLinkAction('/settings/preferences/company-domains'),
  openHelpArticle: () =>
    openInBrowser('https://help.front.com/t/k9sy2s/automatically-join-an-existing-front-company'),
  updateHasSeenDomainLoginBannerAction,
};

export const DomainLoginBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DomainLoginBannerContainerComponent);
